import { Injectable, signal } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders  } from "@angular/common/http";
import { BehaviorSubject, Observable, catchError, throwError } from 'rxjs';
import { enc, SHA512 } from 'crypto-js';
import { AnyCatcher } from "rxjs/internal/AnyCatcher";
import { EncryptionService } from "./encryption.service";
import { environmentUrls } from "src/environments/environment";

@Injectable({
    providedIn: 'root',
})
export class AppService {
    public baseURL = environmentUrls.baseURls.apiUrl;
    // for UAT Builds
    // public baseURL = 'https://apidigitalaouat.axissl.in:7030/NRI/api/';   
    // for Live
    //  public baseURL = 'https://apidigitalao.axisdirect.in/NRIapi/api/';  
    referenceNumber: BehaviorSubject<any> = new BehaviorSubject('');
    masterData: BehaviorSubject<any> = new BehaviorSubject('');
    resumeStatus:BehaviorSubject<any> = new BehaviorSubject('');
    statusData: BehaviorSubject<any> = new BehaviorSubject('');
    addressData:BehaviorSubject<any> = new BehaviorSubject('');
    mfData:BehaviorSubject<any> = new BehaviorSubject('');
    overall:BehaviorSubject<any> = new BehaviorSubject('');
    url: BehaviorSubject<any> = new BehaviorSubject('');
    urlFront: BehaviorSubject<any> = new BehaviorSubject('');
    datas: BehaviorSubject<any> = new BehaviorSubject('');
    FandO: BehaviorSubject<any> = new BehaviorSubject('');
    countryList:any;
    disableMenus: boolean = false;
    status:boolean = false;
    showref:string = "";
    oci = signal<string>('');
    constructor(private http: HttpClient, private encryptService:EncryptionService) { }

    httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      };

    getCountryList(){
      const path = 'DIY/Country';
      return this.http.get(this.baseURL + path, this.httpOptions);
    }

    httpPost(path: string, params: any, checksum:any){
      let encval =  SHA512(checksum).toString(enc.Hex).toLowerCase();
      params.Validate = encval;
      // this.encryptService = params;
      const encryptedInput = this.encryptService.encryptUsingAES256(params);
      const request = {Input: encryptedInput}
      return this.http.post(this.baseURL + path, request , this.httpOptions);
    }
    httpPostNoEncrypt(path: string, params: any, checksum:any){
      let encval =  SHA512(checksum).toString(enc.Hex).toLowerCase();
      params.Validate = encval;
      return this.http.post(this.baseURL + path, params, this.httpOptions);
    }

    httpPostForm(path: string, formData: FormData){
      return this.http.post(this.baseURL + path, formData);
    }

    httpGet(path: string){
      return this.http.get(this.baseURL + path, this.httpOptions);
    }

    getIFSC(search:string):Observable<any> {
      const path = `DIY/GetIFSCCode?IFSCCode=${search}`;
      return this.http.get(this.baseURL + path, this.httpOptions);
    }

    getMICR(ifsc:string):Observable<any> {
      const path = `DIY/GetBankINFOByIFSC?IFSCCode=${ifsc}`;
      return this.http.get(this.baseURL + path, this.httpOptions);
    }

    getRmList(search:string):Observable<any> {
      const path = `DIY/GetRMIDSuggest?RMID=${search}`;
      return this.http.get(this.baseURL + path, this.httpOptions);
    }


    setRefNum(refNum: any){
      this.referenceNumber.next(refNum)
    }

    getRefNum(): Observable<any> {
      return this.referenceNumber.asObservable();
    }
    setImageURLFront(urlFront: any){
      this.urlFront.next(urlFront)
    }

    getImageURLFront(): Observable<any> {
      return this.urlFront.asObservable();
    }
    setImageURLBack(url: any){
      this.url.next(url)
    }

    getImageURLBack(): Observable<any> {
      return this.url.asObservable();
    }

    setPio(data:any){
      this.datas.next(data)
    }

    getPio(): Observable<AnyCatcher> {
      return this.datas.asObservable();
    }
    setBank(data:any){
      this.FandO.next(data)
    }

    getBank(): Observable<AnyCatcher> {
      return this.FandO.asObservable();
    }

    setMasters(data: any){
      this.masterData.next(data)
    }

    getMasters(): Observable<any> {
      return this.masterData.asObservable();
    }
    setResumeSts(data: any){
      this.resumeStatus.next(data)
    }

    getResumeSts(): Observable<any> {
      return this.resumeStatus.asObservable();
    }

    setStatus(data: any){
      this.statusData.next(data)
    }
    setPermanentAddress(data: any){
      this.addressData.next(data)
    }
    getPermanentAddress(): Observable<any> {
      return this.addressData.asObservable();
    }
    setoverall(data: any){
      this.overall.next(data)
    }
    getoverall(): Observable<any>{
      return this.overall.asObservable()
    }
    setMutualFund(data: any){
      this.mfData.next(data)
    }
    getMutualFund(): Observable<any>{
      return this.mfData.asObservable()
    }

    getStatus(): Observable<any> {
      return this.statusData.asObservable();
    }

    getPosition(): Promise<any>
  {
    return new Promise((resolve, reject) => {

      navigator.geolocation.getCurrentPosition(resp => {

          resolve({lng: resp.coords.longitude, lat: resp.coords.latitude});
        },
        err => {
          reject(err);
        });
    });

  }


  getOverallStatus(params:any){
    let URL = "DIY/DIYOverallStatus";

    return this.http.post(this.baseURL + URL , params).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          location.reload();
        }
        return throwError(error);
      })
    )

  }

  checkComplete(data:boolean) {
    this.disableMenus = data;
  }

  getComplete() {
    return this.disableMenus;
  }

  scroll(){
    document.body.scrollTop = 0;
  }

  setStatusLoad(data:boolean){
    this.status = data;
  }

  getStatusLoad(){
    return this.status;
  }

  setRef(data:string){
    const value = this.encryptService.encryptUsingAES256(data);
    sessionStorage.setItem('ref', value);
  }

  getRef() {
    const value = sessionStorage.getItem('ref');
    if (value) {
      return this.encryptService.decryptUsingAES256(value);
    }
  }

  setOci(data:string){
    this.oci.set(data);
  }
  getOci(){
    return this.oci();
  }

}